import { useEffect, useState } from "react";

export const useDetectTheme = (): { isDarkTheme: boolean } => {
  const [isDarkTheme, setIsDarkTheme] = useState<boolean>(false);

  useEffect(() => {
    const detectTheme = () => {
      const isDark = document.body.classList.contains("page--dark");
      setIsDarkTheme(isDark);
    };

    detectTheme();

    const observer = new MutationObserver(detectTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  return { isDarkTheme };
};
